import { axios } from '../index';

const { REACT_APP_API_GATEWAY, REACT_APP_BACKEND_BRAND } = process.env;

export const readSiren = (
  siren
): Promise<NonNullable<CommercialRegisterService.Schemas.GetSirenDataResponse['customerData']>['companyData']> => {
  const url = `${REACT_APP_API_GATEWAY}/siren-service/${REACT_APP_BACKEND_BRAND}/${siren}`;

  const notFoundResponse = {
    name: '',
    activityCode: '',
    companyRegistrationNumber: '',
    companyCategory: '',
    foundationDate: '',
    entityLegalFormCode: '',
  };

  return axios
    .get<CommercialRegisterService.Schemas.GetSirenDataResponse>(url)
    .then((response) => {
      if (!response) {
        return notFoundResponse;
      }
      // To avoid problems with incorrect foundation date in miles overwite dummy response from siren-service
      if (response?.data?.customerData?.companyData?.foundationDate === '1900-01-01') {
        response.data.customerData.companyData.foundationDate = '';
      }
      return response?.data?.customerData?.companyData || notFoundResponse;
    })
    .catch((error) => {
      if (error.response?.status === 404) {
        return notFoundResponse;
      }

      throw error;
    });
};
